module.exports = __webpack_public_path__ + "img/csv-file.cb8d622f.svg";